<template>
  <v-container fluid fill-height class="py-4">
    <div v-if="forceRefresh" />
    <v-layout flex align-center justify-center>
      <v-card max-width="300">
        <v-toolbar dark>
          <v-toolbar-title class="white--text text-center"><h4>ENTRAR</h4></v-toolbar-title>
        </v-toolbar>
        <v-layout align-center justify-center column>
          <div class="ma-4">
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Nº usuário ou Email"
                v-model="username"
                :rules="[usernameRules]"
                prepend-icon="mdi-account"
                class="digite"
                @keyup="user_error_clear"
              ></v-text-field>
              <v-text-field
                ref="password"
                label="Senha"
                v-model="password"
                min="8"
                :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                counter
                prepend-icon="mdi-lock"
                class="digite"
                :rules="passwordRules"
                :error-messages="user_error"
                @keyup="user_error_clear"
                @keyup.enter.stop="submit"
                autocomplete="new-password"
              ></v-text-field>
              <div id="firebaseui-auth-container" class="mt-4 "></div>
              <div class="pa-4 text-center">
                <div v-if="appname=='portal'"><a @click="alterarSenha=false; cadastro=true;">Ainda não me cadastrei</a></div>
                <div><a @click="alterarSenha=true; cadastro=true;">Esqueci minha senha</a></div>
              </div>
              <v-layout align-center justify-center>
                <v-btn light class="my-4" @click="submit" :loading="enviando" :disabled="!valid">Enviar</v-btn>
              </v-layout>
            </v-form>
          </div>
        </v-layout>
      </v-card>
    </v-layout>

    <!--
      Cadastrar usuário
    -->
    <v-bottom-sheet v-model="cadastro" width="550">
      <v-sheet>
        <v-layout column>
          <v-row class="mx-2 mt-3 mb-0">
            <v-spacer></v-spacer>
            <h3 v-if="alterarSenha">ALTERAR SENHA USUÁRIO</h3>
            <h3 v-else>CADASTRO DE USUÁRIO</h3>
            <v-spacer></v-spacer>
            <a class="mr-4" @click="cadastro = false">
              <b style="color: red;">X</b>
            </a>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-stepper v-model="stepper" style="width: 90%;">
              <v-stepper-header class="indigo">
                <v-stepper-step :complete="stepper>1" step="1">
                  <span class="white--text" >Email</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="stepper>2" step="2">
                  <span class="white--text">Código verificação</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="stepper>3" step="3">
                  <span class="white--text">Dados</span>
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-text-field
                    v-model.trim="username"
                    label="Seu email"
                    :rules = "[ v => ( v ? (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email inválido') : true) ]"
                    @keyup.enter.stop="verificarEmail"
                  />
                  <v-row class="ma-3 align-center justify-center">
                    <v-btn 
                      class="ma-2"
                      color="indigo" dark
                      :loading="enviando"
                      @click="verificarEmail"
                    >ENVIAR</v-btn>
                    <v-btn
                      class="ma-2"
                      @click="passo2"
                    >JÁ TENHO O CÓDIGO</v-btn>
                  </v-row>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <div style="text-align: justify;">
                    Enviamos uma mensagem para confirmar que você é o proprietário do email <b>{{username}}</b>.
                    Abra o email e digite abaixo o código recebido. O código é valido até {{ dateCode | prettyDatetime }}.
                  </div>
                  <v-text-field
                    v-model.trim="codeEmail"
                    label="Digite o Código de Verificação"
                    @keyup.enter.stop="confirmar"
                  />
                  <v-row class="ma-3 justify-center">
                    <v-btn 
                      class="ma-2"
                      @click="stepper=1"
                    >VOLTAR</v-btn>
                    <v-btn 
                      class="ma-2"
                      color="indigo" dark
                      :loading="enviando"
                      @click="confirmar"
                    >CONFIRMAR</v-btn>
                  </v-row>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <div v-if="!alterarSenha">
                    <v-text-field
                      v-model.trim="nomeCompleto"
                      label="Nome completo"
                      :rules="[ rulesName ]"
                    />
                    <v-text-field
                      v-model.trim="celular"
                      label="Celular"
                      v-mask="mask"
                    />
                  </div>
                  <v-text-field
                    v-model.trim="password"
                    label="Senha"
                    :type="hidePwd ? 'password' : 'text'"
                    :append-icon="hidePwd ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPwd"
                    :rules="[ rulesPwd ]"
                  />
                  <v-text-field
                    v-model.trim="senha"
                    label="Redigite a senha"
                    :type="hidePwd ? 'password' : 'text'"
                    :append-icon="hidePwd ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPwd"
                    :rules="[ rulesRePwd ]"
                    @keyup.enter.stop="cadastrar"
                  />

                  <v-row class="ma-3 justify-center">
                    <v-btn 
                      class="ma-2"
                      @click="stepper=1"
                    >VOLTAR</v-btn>
                    <v-btn 
                      class="ma-2"
                      color="indigo" dark
                      :loading="enviando"
                      @click="cadastrar"
                    >
                      <div v-if="alterarSenha">ALTERAR SENHA</div>
                      <div v-else>CADASTRAR</div>
                    </v-btn>
                  </v-row>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
            <v-spacer></v-spacer>
          </v-row>
        </v-layout>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
  import auth from '@/js/base/auth'
  import { mapState } from 'vuex'
  import ajax from '@/js/base/ajax'
  import { mask } from 'vue-the-mask'

  export default {
    name: 'auth',
     directives: {
      mask: mask
    },

    data () {
      return {
        enviando: false,
        valid: false,
        e1: true,
        password: '',
        passwordRules: [ (v) => !!v || 'Senha obrigatória' ],
        username: '',
        user_error: '',
        cadastro: false,
        esqueci: false,
        stepper: 1,
        dateCode: '',
        codeEmail: '',
        saveCodeEmail: null,
        nomeCompleto: '',
        celular: '',
        senha: '',
        mask: '(##) #####-####',
        hidePwd: true,
        alterarSenha: false,
      }
    },

    computed: {
      ...mapState(['forceRefresh', 'portalURI', 'appname']),
    },

    watch: {
      forceRefresh () {
        if (document.getElementById('firebaseui-auth-container')) {
          auth.authForm('#firebaseui-auth-container')
          setTimeout(this.translateFirebase, 500)
        }
      },

      cadastro (val) {
        if (!val) {
          this.stepper = 1
          this.codeEmail = ''
        }
      }, 

      stepper (val) {
        if (val == 2) {
          this.codeEmail = ''
        }
        if (val == 3) {
          this.nomeCompleto = ''
          this.celular = ''
          this.password = ''
          this.senha = ''
        }
      }
    },

    mounted () {
      let username = localStorage.getItem('username')
      if (username) this.username = username
      auth.authForm('#firebaseui-auth-container')
      setTimeout(this.translateFirebase, 500)

      // carregar parametros quando usuario recebeu email de convite de cadastro
      let q = this.$route.query 
      if (q.user) this.username = q.user
      if (q.code) {
        this.cadastro = true
        this.stepper = 2
        this.codeEmail = q.code
        this.saveCodeEmail = q.code
        this.confirmar()
      }
    },

    methods: {
      // isPending () {
      //   return auth.ui && auth.ui.isPendingRedirect()
      // },

      usernameRules (val) {
        let result = true
        val = (val || '').trim()
        if (!val)
          result = 'Obrigatório'
        else if ((!(parseInt(val) > 0)) &&
            (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(val))))
          result = 'Nº ou Email inválido'
        return result
      },

      submit () {
        let vm = this
        vm.user_error = ''
        if (this.$refs.form.validate()) {
          vm.enviando = true
          setTimeout(() => { vm.enviando = false }, 3000)

          auth.loginByUsername(
            this.username,
            this.password,
            data => {
              vm.enviando = false
              if (data.user_error) {
                vm.user_error = data.user_error
              } else {
                localStorage.setItem('username', this.username)
                vm.password = ''
              }
            }
          )
        }
      },

      translateFirebase () {
        let e = document.getElementsByClassName('firebaseui-idp-text-long')
        if (e.length > 0) {
          for (let i = 0; i < e.length; i++) {
            if (e[i].textContent === 'Sign in with Facebook') e[i].textContent = 'Use Facebook'
            else if (e[i].textContent === 'Sign in with Google') e[i].textContent = 'Use conta Google'
            else if (e[i].textContent === 'Sign in with email') e[i].textContent = 'Use seu Email'
          }
        } else {
          setTimeout(this.translateFirebase, 500)
        }
      },

      user_error_clear () {
        this.user_error = ''
      },

      completed (val) {
        return val >= 0
      },

      passo2 () {
        let result = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.username)
        if (!result) {
          this.$store.commit('ADD_ALERT', 'Email inválido !')
        } else {
          this.stepper = 2
        }
      },

      verificarEmail () {
        let result = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.username)
        if (!result) {
          this.$store.commit('ADD_ALERT', 'Email inválido !')
        } else {
          var that = this
          that.enviando = true
          this.$store.commit('SET_USER', null)
          this.$store.commit('SET_TOKEN', 'undefined')
          ajax.request(
            'account.php',
            { 
              service: 'confirmEmail',
              email: this.username,
              alterarSenha: this.alterarSenha
            },
            response => {
              that.dateCode = response.data.datetime
              if (response.data.ok) {
                that.stepper = 2
              }
              else if (response.data.emailExist) {
                that.confAlterarSenha()
              }
            },
            null, 
            () => {
              that.enviando = false
            }, 
            this.portalURI,
            false
          )
        }
      },

      async confAlterarSenha () {
        if (await this.$confirm('<BR>Email [ ' + this.username + ' ] já cadastrado. Deseja alterar a senha do usuário ?', { title: 'Alterar senha' })) {
          this.alterarSenha = true
          this.verificarEmail()
        }
      },

      confirmar () {
        if (!this.codeEmail) {
          this.$store.commit('ADD_ALERT', 'Informe o Código de Verificação enviado para seu email !')
        } else {
          var that = this
          that.enviando = true
          this.$store.commit('SET_USER', null)
          this.$store.commit('SET_TOKEN', 'undefined')
          ajax.request(
            'account.php',
            { 
              service: 'confirmCode',
              email: this.username,
              code: this.codeEmail
            },
            response => {
              if (response.data.ok) {
                that.stepper = 3
              }
            },
            null, 
            () => {
              that.enviando = false
            }, 
            this.portalURI,
            false
          )
        }
      },

      cadastrar () {
        if (!this.rulesName(this.nomeCompleto)) {
          this.$store.commit('ADD_ALERT', 'Preencha o Nome do Usuário !')
        }
        else if (!this.rulesPwd(this.password)) {
          this.$store.commit('ADD_ALERT', 'Preencha a Senha corretamente !')
        }
        else if (!this.rulesRePwd(this.senha)) {
          this.$store.commit('ADD_ALERT', 'Redigite a senha igual ao campo Senha !')
        }
        else {
          var that = this
          that.enviando = true
          this.$store.commit('SET_USER', null)
          this.$store.commit('SET_TOKEN', 'undefined')
          if (this.saveCodeEmail) {
            this.codeEmail = this.saveCodeEmail
            this.saveCodeEmail = null
          }
          ajax.request(
            'account.php',
            { 
              service: 'addUserByEmail',
              email: this.username,
              code: this.codeEmail,
              alterarSenha: this.alterarSenha,
              nome: this.nomeCompleto,
              celular: this.celular,
              senha: this.password
            },
            response => {
              if (response.data.ok) {
                that.cadastro = false
                that.submit()
              }
            },
            null, 
            () => {
              that.enviando = false
            }, 
            this.portalURI,
            false
          )
        }
      },

      showPwd () {
        this.hidePwd = !this.hidePwd
      },

      rulesPwd (v) {
        v = (v || '').trim()
        let result = true
        // pelo menos uma minuscula + 1 maiúscula + caracter especial e 6 carac sem repeticao
        // let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])(?:([0-9a-zA-Z$*&@#])(?!\1)){6,}$/;
        if (v) {
          let regex = /^(?:(.)(?!\1)){1,}$/;
          if (regex.test(v)) {
            // verifica tres caracteres sequenciais
            for (let i = 0; i < v.length-2; i++) {
              if (v[i].charCodeAt() == (v[i+1].charCodeAt() - 1) && v[i].charCodeAt() == (v[i+2].charCodeAt() - 2)) {
                result = 'Não use letras sequênciais (Ex. 123)'
                break
              }
            }
            if (result === true && v.length < 6) {
              result = 'Mínimo 6 caracteres'
            }
          } else {
            result = 'Não repita letras  (Ex. 00 ou 11)'
          }
        }
        return result
      },

      rulesRePwd (v) {
        v = (v || '').trim()
        return (v && v === this.password) || 'Confirmação incorreta'
      }, 

      rulesName (v) {
        v = (v || '').trim()
        return v.length >= 6 || 'Confirmação incorreta'
      }
    }
  }
</script>

<style scoped>
  @import "../../../node_modules/firebaseui/dist/firebaseui.css";
  .my-flex {
    background-color: white;
  }
  .digite {
    margin-bottom:10px;
  }
  .text-center {
    width: 100%;
    text-align: center;
  }
</style>

<style>
  v-application ol, .v-application ul {
    padding-left: 0px;
  }
</style>
